











































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { UserInfo } from '@/types/root';
import MLabel from 'components/basic/Label.vue';

@Component({
  components: {
    MLabel
  }
})
export default class Header extends Vue {
  @Action('getUserInfo') private getUserInfo!: Function;
  @Getter('isLogin') private isLogin!: boolean;
  @Getter('userInfo') private userInfo!: UserInfo;

  private isActiveMenu: boolean = false;

  toggleMenu(): void {
    this.isActiveMenu = !this.isActiveMenu;
  }

  closeMenu(): void {
    this.isActiveMenu = false;
  }

  login(): void {
    if (this.isLogin) {
      this.$router.push({ name: 'user' });
    } else {
      this.getUserInfo();
      // hack for android weixin explorer
      // on iOS, the following codes will not executed because of the redirecting.
      setTimeout(() => {
        this.getUserInfo();
      }, 2000);
    }
  }
}
